async function getSearchResult(params, navParams) {
    try {

        if (!params || params === 'undefined') {
            params = null;
        }

        if (!navParams || navParams === 'undefined') {
            navParams = null;
        }
        let response = await BX.ajax.runComponentAction(
            componentSearchPageResult.componentName,
            'getSearchResult', {
                mode: 'class',
                signedParameters: componentSearchPageResult.signedParameters,
                data: {
                    templateName: componentSearchPageResult.templateName,
                    params: params,
                    navParams: navParams,
                },
            }).then(function(response) {
            return response;
        });

        return new Promise((resolve, reject) => {
            resolve(response);
        });
    } catch (err) {
        return err.message;
    }
}